import {MODAL_PORTAL} from './portalIds';
import {usePortalElement} from './usePortalElement';

export function useModalPortalElement() {
  return usePortalElement(MODAL_PORTAL);
}
